import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../App";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { Download, FileText } from "lucide-react";

export default function PortalHistorialPage() {
  const { token, API } = useAuth();
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const [items, setItems] = useState([]);

  useEffect(() => { axios.get(`${API}/recaudaciones`, auth).then(r => setItems(r.data)); }, []);

  const fmt = n => `Bs. ${(Number(n)||0).toLocaleString("es-VE", { maximumFractionDigits: 2 })}`;

  const descargar = async (id, nro) => {
    const r = await axios.get(`${API}/recaudaciones/${id}/recibo-pdf`, { ...auth, responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    const a = document.createElement("a"); a.href = url; a.download = `recibo_${nro}.pdf`; a.click(); URL.revokeObjectURL(url);
  };

  const badge = (e) => {
    if (e === "validado") return <Badge className="bg-green-100 text-green-800 hover:bg-green-100">Validado</Badge>;
    if (e === "rechazado") return <Badge className="bg-rose-100 text-rose-800 hover:bg-rose-100">Rechazado</Badge>;
    return <Badge className="bg-orange-100 text-orange-800 hover:bg-orange-100">Pendiente</Badge>;
  };

  return (
    <div className="space-y-6" data-testid="portal-historial-page">
      <div>
        <h1 className="font-display font-extrabold text-3xl text-green-900 flex items-center gap-3">
          <FileText className="w-8 h-8 text-orange-500" />Historial de pagos
        </h1>
        <p className="text-green-700/70 mt-1">Descargue los recibos digitales en PDF</p>
      </div>

      <Card className="p-4 border-green-100">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-green-50 text-green-900"><tr>
              <th className="text-left p-2.5">Comprobante</th><th className="text-left p-2.5">Fecha</th><th className="text-left p-2.5">Método</th><th className="text-left p-2.5">Referencia</th><th className="text-right p-2.5">Monto</th><th className="text-center p-2.5">Estado</th><th className="text-right p-2.5">Recibo</th>
            </tr></thead>
            <tbody>{items.map(p => (
              <tr key={p.id} className="border-b border-green-50">
                <td className="p-2.5 font-mono">{p.nro_comprobante || <span className="text-slate-400 italic">Sin asignar</span>}</td>
                <td className="p-2.5">{p.fecha_pago}</td>
                <td className="p-2.5 capitalize">{p.metodo_pago}</td>
                <td className="p-2.5 font-mono">{p.referencia||"-"}</td>
                <td className="p-2.5 text-right font-semibold">{fmt(p.monto_pagado)}</td>
                <td className="p-2.5 text-center">{badge(p.estado_validacion)}</td>
                <td className="p-2.5 text-right">
                  {p.estado_validacion === "validado" ? (
                    <Button size="sm" variant="ghost" onClick={() => descargar(p.id, p.nro_comprobante)} data-testid={`btn-pdf-${p.nro_comprobante}`}>
                      <Download className="w-4 h-4 text-green-700" />
                    </Button>
                  ) : (
                    <span className="text-[11px] text-slate-400 italic" data-testid={`no-pdf-${p.nro_comprobante}`}>—</span>
                  )}
                </td>
              </tr>
            ))}{!items.length && <tr><td colSpan="7" className="p-8 text-center text-slate-400">Aún no tiene pagos registrados</td></tr>}</tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
